import { render } from "./PriorityChip.vue?vue&type=template&id=76d78d2e&scoped=true"
import script from "./PriorityChip.vue?vue&type=script&lang=js"
export * from "./PriorityChip.vue?vue&type=script&lang=js"

import "./PriorityChip.vue?vue&type=style&index=0&id=76d78d2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d78d2e"]])

export default __exports__